import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Stack, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { useGetBotAllowedUsers } from '../../api/getAllowedUsers';
import { useRemoveAllowedUser } from '../../api/removeAllowedUser';

import { AddModal } from './AddModal';
import { EditModal } from './EditModal';

import { AddButton } from '@/components';
import { ConfirmModal } from '@/components/Modals/Confirm';
import { COLORS } from '@/utils/colors';

export const AllowedUsers = () => {
  const { data, isLoading } = useGetBotAllowedUsers();
  const removeAllowedUser = useRemoveAllowedUser();

  return (
    <>
      <Grid columns={5}>
        {data?.users.map((user) => (
          <Grid.Col key={user._id} span={1}>
            <Paper shadow="md" radius="md" p="md">
              <Group justify="space-between">
                <Stack gap="xs">
                  <Text size="sm" style={{ wordBreak: 'break-word' }}>
                    {user.name}
                  </Text>
                </Stack>
                <Group gap="xs">
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(EditModal, { user })}
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <Tooltip label="Edit Allowed User">
                      <IconEdit color={COLORS.text} />
                    </Tooltip>
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    color="red"
                    radius="md"
                    onClick={() =>
                      NiceModal.show(ConfirmModal, {
                        title: `Remove allowed user (${user.name})?`,
                        onSuccess: () => removeAllowedUser.mutate({ _id: user._id }),
                      })
                    }
                  >
                    <Tooltip label="Remove Allowed User">
                      <IconTrash color={COLORS.text} />
                    </Tooltip>
                  </ActionIcon>
                </Group>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton size={60} isLoading={isLoading} onClick={() => NiceModal.show(AddModal)} />
    </>
  );
};
